import React, { useState } from 'react';
import { Package2, Coins } from 'lucide-react';
import { NavLink, Link } from "react-router-dom"; // For navigation
import Login from "./Login";
import Register from "./Register";
import Tracking from "../assets/Tracking.png";
import Cashback from "../assets/Cashback-1.png";
import BonusGift from "../assets/BonusGift.png";




const GuestPop = ({ onGuestCheckout }) => {
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showRegisterPopup, setShowRegisterPopup] = useState(false);

  const toggleLoginPopup = () => setShowLoginPopup(!showLoginPopup);
  const toggleRegisterPopup = () => setShowRegisterPopup(!showRegisterPopup);

  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center bg-black/50 px-4">
        <div className="w-full max-w-md mx-auto rounded-lg bg-primary p-6 shadow-xl sm:mt-10">
          <h1 className="mb-2 text-3xl font-bold text-red-600 font-inter mt-10">Hold On!</h1>

          <p className="mb-4 text-md text-red-600 font-inter ">You are not signed in.</p>

          <h2 className="mb-4 text-md font-bold font-inter ">You will not be able to:</h2>



          <div className="mb-4 space-y-2 mt-2">

            <div className=" sm:flex-row gap-2">
              <div className="flex items-center justify-between gap-2 rounded-md bg-black px-3 py-2 text-primary w-48 lg:w-[192px]">
                <span className="text-sm font-bold font-inter whitespace-nowrap">Get 10% Bonus</span>
                <img src={BonusGift} className="w-6 h-6" />
              </div>

              <div className="flex mt-2 items-center justify-between gap-2 rounded-md bg-black px-3 py-2 text-primary w-48 lg:w-[192px]">
                <span className="text-sm font-bold font-inter whitespace-nowrap">Track your order</span>
                <img src={Tracking} className="w-6 h-6" />
              </div>
            </div>


            {/* <div className="flex gap-2 rounded-md bg-black px-3 py-2 text-primary w-1/2 ">
              <span className="text-sm font-inter">Receive Cashback</span>
              <img src={Tracking} className="w-4 h-4 ml-auto" />
            </div> */}
          </div>

          <div className="mb-2 ">
            <button
              onClick={toggleLoginPopup}
              className="text-xl font-bold underline hover:no-underline font-inter"
            >
              Sign in
            </button>
          </div>

          <p className="mb-1 text-sm font-inter ">Don't have an account?</p>
          <button
            onClick={toggleRegisterPopup}
            className="text-xs underline lg:text-sm font-medium font-inter"
          >
            Create your account now and get $5 Cashback today.
          </button>



          <button
            type="button"
            onClick={onGuestCheckout}
            className="mt-4 ml-10 mb-10 w-[80%] justify-center items-center rounded-md bg-black px-4 py-2 text-sm font-medium text-primary hover:bg-black/90 font-inter block"
          >
            Continue as Guest
          </button>
        </div>
      </div>


      {showLoginPopup && <Login onClose={toggleLoginPopup} />}
      {showRegisterPopup && <Register onClose={toggleRegisterPopup} />}

    </>
  );
};

export default GuestPop;
